import script from "./PathwayHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PathwayHeader.vue?vue&type=script&setup=true&lang=ts"

import "./PathwayHeader.vue?vue&type=style&index=0&id=0c36ad80&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c36ad80"]])

export default __exports__